import React from 'react';
import { AppointmentConfirmationCreate } from '~/presentation/pages';

export const MakeAppointmentConfirmationPage: React.FC = () => {
  return <AppointmentConfirmationCreate />;
};
